import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "./velmartAPI";

// const getToken = () => {
//     return JSON.parse(localStorage.getItem("token"));
// };

export const noLoadingReqAPI = createApi({
    reducerPath: "noLoadingReqAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers) => {
            headers.set("Accept", "application/json");
            headers.set("Content-Type", "application/json");
            return headers;
        },
        credentials: "include",
    }),
    endpoints: (builder) => ({
        getPageUnload: builder.query({
            query: (url) => ({ url: "api/" + url, method: "get" }),
        }),
    }),
});

export const { useGetPageUnloadQuery } = noLoadingReqAPI;
